export const loadBillingInfo = () => async (dispatch, getState, { api }) => {
    dispatch({ type: 'BILLING_SETTINGS__REQUEST' });
    try {
        const { billing_state, billing_settings } = await api.billing_info();
        dispatch({
            type: 'BILLING_SETTINGS__OK',
            data: billing_settings,
        });
        dispatch({
            type: 'BILLING_STATE__OK',
            data: billing_state,
        });
    }
    catch (error) {
        dispatch({
            type: 'BILLING_SETTINGS__FAIL',
            error,
        });
    }
};
